import React, { useEffect, useState } from 'react';
import apiClient from '../../api/apiClient';   // ✅ جایگزین axiosPublicInstance
import ContentCard from '../Product/ContentCard';
import { BookOpen, AlertTriangle } from 'lucide-react';

const SkeletonCard = () => (
  <div className="bg-white rounded-lg shadow-sm overflow-hidden animate-pulse">
    <div className="h-40 bg-gray-200"></div>
    <div className="p-3 space-y-2">
      <div className="h-4 bg-gray-200 rounded w-3/4"></div>
      <div className="h-3 bg-gray-200 rounded w-1/2"></div>
      <div className="h-3 bg-gray-200 rounded w-1/4"></div>
    </div>
  </div>
);

const RelatedProductsByBookTags = ({ tags, currentBookSlug }) => {
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const limit = 8;

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    if (!tags?.length || !currentBookSlug) {
      setLoading(false);
      return;
    }

    const fetchRelated = async () => {
      setLoading(true);
      setError(null);
      try {
        // 🎯 مسیر را بر اساس بک‌اند موجود تنظیم کنید
        // اگر بک‌اند محصولات مرتبط با تگ‌های کتاب را در این endpoint دارد، از همان استفاده شود
        // در غیر این‌صورت از endpoint موجود: /products/related-by-book-tags/ استفاده کنید
        const url = `/products/related-by-tags/?tags=${encodeURIComponent(tags.join(','))}&exclude_book_slug=${encodeURIComponent(currentBookSlug)}&limit=${limit}`;

        console.log(`Fetching related products: ${url}`);
        const response = await apiClient.get(url, { signal });

        // پشتیبانی از هر دو ساختار
        const results = response.data.results || response.data || [];
        setRelated(results);
      } catch (err) {
        if (err.name === 'CanceledError') return;
        console.error('Error fetching related products:', err);
        setError('خطا در بارگذاری محتوای مرتبط.');
      } finally {
        setLoading(false);
      }
    };

    fetchRelated();
    return () => controller.abort();
  }, [tags, currentBookSlug]);

  if (error) {
    return (
      <section className="mb-8 px-4">
        <div className="text-center text-red-600 py-8">
          <AlertTriangle className="inline-block w-8 h-8 mb-2" />
          <p>{error}</p>
        </div>
      </section>
    );
  }

  if (!loading && related.length === 0) return null;

  return (
    <section className="mb-8 px-4">
      <h2 className="text-[14px] font-black text-gray-600 mb-6 text-right">
        محتـوای مرتـبط با این کـتاب
      </h2>
      <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {loading
          ? Array(limit).fill(0).map((_, i) => <SkeletonCard key={`sk-${i}`} />)
          : related.map((item) => (
              <ContentCard
                key={item.id || item.slug}
                data={{
                  ...item,
                  productUrl: item.product_url || `/products/${item.slug}`,
                  cover_url: item.cover_url || null,
                }}
              />
            ))
        }
      </div>
    </section>
  );
};

export default RelatedProductsByBookTags;